// pages/DocumentViewer.js
import React from 'react';

const DocumentViewer = ({ pdf, title }) => {
  return (
    <div className="p-4">
      <h2 className="text-center mb-4">{title}</h2>
      <iframe
        src={pdf}
        width="100%"
        height="800px"
        style={{ border: 'none' }}
        title={title}
      ></iframe>
    </div>
  );
};

export default DocumentViewer;
